import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Paperclip, Image as ImageIcon, BarChart2, ArrowUp, Mic, Heart, Sparkles, Users, User, Instagram } from 'lucide-react';
const PROMPTS = ['Píde a tu IA que cree una estrategia de anuncios para tus campañas...', 'Genera gráficos y videos con tu IA para postear en Facebook e Instagram...', 'Permite que Danke Hub IA lance campañas por tí a través de tu IA...', 'Delega a Whatsapp IA  para que filtre a tus leads automáticamente...'];
export function ChatInput() {
  const [currentPromptIndex, setCurrentPromptIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const currentPrompt = PROMPTS[currentPromptIndex];
    if (isPaused) {
      const timeout = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, 2000);
      return () => clearTimeout(timeout);
    }
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        // Typing
        if (displayText.length < currentPrompt.length) {
          setDisplayText(currentPrompt.slice(0, displayText.length + 1));
        } else {
          setIsPaused(true);
        }
      } else {
        // Deleting
        if (displayText.length > 0) {
          setDisplayText(currentPrompt.slice(0, displayText.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentPromptIndex(prev => (prev + 1) % PROMPTS.length);
        }
      }
    }, isDeleting ? 30 : 50);
    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, isPaused, currentPromptIndex]);
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} animate={{
    opacity: 1,
    y: [0, -8, 0] // Floating animation
  }} transition={{
    opacity: {
      duration: 0.8,
      delay: 0.6
    },
    y: {
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      repeatType: 'reverse'
    }
  }} className="w-full max-w-3xl mx-auto mt-12 relative z-10" data-id="element-11">
      <div className="bg-[#FDF8F3] rounded-3xl shadow-xl border border-white/50 p-4 md:p-6 min-h-[180px] flex flex-col justify-between transition-shadow hover:shadow-2xl duration-500" data-id="element-12">
        {/* Input Area */}
        <div className="flex-1" data-id="element-13">
          <p className="text-gray-500 text-lg md:text-xl font-light leading-relaxed" data-id="element-14">
            {displayText}
            <span className="inline-block w-0.5 h-5 ml-1 bg-gray-400 animate-pulse align-middle" data-id="element-15" />
          </p>
        </div>

        {/* Toolbar */}
        <div className="flex items-center justify-between mt-8 pt-2" data-id="element-16">
          <div className="flex items-center gap-2 md:gap-4" data-id="element-17">
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-black/5 rounded-full transition-all" aria-label="Add" data-id="element-18">
              <Plus className="w-5 h-5" data-id="element-19" />
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-black/5 rounded-full transition-all text-sm font-medium" data-id="element-20">
              <BarChart2 className="w-4 h-4" data-id="element-21" />
              <span className="hidden sm:inline" data-id="element-22">Objetivos</span>
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-black/5 rounded-full transition-all text-sm font-medium" data-id="element-23">
              <Heart className="w-4 h-4" data-id="element-24" />
              <span className="hidden sm:inline" data-id="element-25">Canales</span>
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-black/5 rounded-full transition-all text-sm font-medium" data-id="element-26">
              <Instagram className="w-4 h-4" data-id="element-27" />
              <span className="hidden sm:inline" data-id="element-28">Target</span>
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-black/5 rounded-full transition-all text-sm font-medium" data-id="element-29">
              <span className="hidden sm:inline" data-id="element-30">...</span>
            </button>
          </div>

          <div className="flex items-center gap-3" data-id="element-31">
            <button className="flex items-center gap-2 px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-black/5 rounded-full transition-all text-sm font-medium" data-id="element-32">
              <span className="hidden sm:inline" data-id="element-33">Estrategía 360°</span>
            </button>
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-black/5 rounded-full transition-all" data-id="element-34">
              <Sparkles className="w-5 h-5" data-id="element-35" />
            </button>
            <button className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center text-white hover:bg-black hover:scale-110 active:scale-95 transition-all duration-300 shadow-lg group" aria-label="Send" data-id="element-36">
              <ArrowUp className="w-5 h-5 group-hover:-translate-y-0.5 transition-transform" data-id="element-37" />
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}